import React, { useState } from 'react';
import {
  Box,
  Typography,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ContentContainer, StyledAccordion, StyledPaper, VideoContainer } from './styled';
import { tutorialSections } from './consts';
import MarkdownRenderer from '../../components/MarkdownRenderer';

function TutorialContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledPaper>
      {tutorialSections.map((section, index) => (
        <StyledAccordion 
          key={section.id}
          expanded={expanded === `panel${section.id}`}
          onChange={handleChange(`panel${section.id}`)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: theme.palette.grey[100],
              '&:hover': {
                backgroundColor: ({ palette }) => 
                  expanded === `panel${section.id}` 
                    ? palette.primary.dark 
                    : palette.grey[200],
              },
              borderRadius: '1rem',
              transition: 'background-color 0.3s ease', // Optional: adds smooth transition
            }}
          >
            <Typography variant="h6">
              {section.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: theme.spacing(2) }}> {/* Added padding */}
            {isMobile ? (
              // Mobile Layout
              <Box>
                <VideoContainer>
                  <iframe
                    width="100%"
                    height="200"
                    src={section.videoUrl}
                    title={section.title}
                    frameBorder="0"
                    allowFullScreen
                  />
                </VideoContainer>
                <ContentContainer>
                  <MarkdownRenderer content={section.transcriptContent} />
                </ContentContainer>
              </Box>
            ) : (
              // Desktop Layout
              <Box
                display="flex"
                flexDirection={index % 2 === 0 ? 'row' : 'row-reverse'}
                gap={2} // Added gap between video and content
              >
                <VideoContainer sx={{ flex: 1 }}>
                <iframe 
                  width="560"
                  height="315" 
                  src={section.videoUrl} 
                  title="YouTube video player" 
                  frameborder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerpolicy="strict-origin-when-cross-origin" 
                  allowfullscreen
                />
                </VideoContainer>
                <ContentContainer>
                  <MarkdownRenderer content={section.transcriptContent} />
                </ContentContainer>
              </Box>
            )}
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </StyledPaper>
  );
}

export default TutorialContainer;